import { render, staticRenderFns } from "./SeguroAlunos.vue?vue&type=template&id=7a284fb8&scoped=true&"
import script from "./SeguroAlunos.vue?vue&type=script&lang=js&"
export * from "./SeguroAlunos.vue?vue&type=script&lang=js&"
import style0 from "./SeguroAlunos.vue?vue&type=style&index=0&id=7a284fb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a284fb8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VContainer,VFlex,VIcon,VLayout})
